import { React, useRef } from "react";
import { TileLayer, Marker, Popup, MapContainer } from "react-leaflet";
import Leaflet from "leaflet";
import { FiEdit3 } from "react-icons/fi";
import MenuIcon from "@mui/icons-material/Menu";
import "./styles.css";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSatisfactionMapFilter } from "../../hooks/map/useSatisfactionMapFilter";
import InfoReviewComplaint from "./infoReviewComplaint";

const SATISFACTION_COLORS = {
  "Muito Satisfeito": { color: "#6EB44D" },
  "Satisfeito": { color: "#B5DF66" },
  "Neutro": { color: "#FADB43" },
  "Insatisfeito": { color: "#F57A22" },
  "Muito Insatisfeito": { color: "#C63637" },
  Padrão: { color: "#808080" },
};

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

const getSatisfactionIcon = (complaint) => {
  let statusKey = "Padrão";
  if (complaint?.evaluation?.review != null) {
    const rating = complaint.evaluation.review;
    if (rating === 5) statusKey = "Muito Satisfeito";
    else if (rating === 4) statusKey = "Satisfeito";
    else if (rating === 3) statusKey = "Neutro";
    else if (rating === 2) statusKey = "Insatisfeito";
    else if (rating === 1) statusKey = "Muito Insatisfeito";
  }

  const color = SATISFACTION_COLORS[statusKey].color;
  const rgb = hexToRgb(color);

  return Leaflet.divIcon({
    html: '<span class="satisfaction-marker-icon" style="background-color: rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.7);"></span>',
    className: "leaflet-div-icon",
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });
};

export default function SatisfactionMap() {
  const navigate = useNavigate();
  const mapRef = useRef(null);

  const {
    mapPosition,
    mapZoom,
    selectedItem,
    setSelectedItem,
    complaints,
  } = useSatisfactionMapFilter();

  function formatDate(date) {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <Grid
      id={"map-side"}
      container
      style={{ width: "100%", height: "100%" }}
      justifyContent="center"
    >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div
          ref={mapRef}
          className="map"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <MapContainer
            center={mapPosition}
            zoom={mapZoom}
            scrollWheelZoom={false}
            style={{ width: "100%", height: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {complaints &&
              complaints.map((response) => {
                const lat = Number(response.latitude);
                const lon = Number(response.longitute);
                if (isNaN(lat) || isNaN(lon)) return null;
                return (
                  <Marker
                    key={response.id}
                    position={[lat, lon]}
                    icon={getSatisfactionIcon(response)}
                  >
                    <Popup
                      closeButton={false}
                      minWidth={240}
                      maxWidth={240}
                      className="map-popup"
                    >
                      <div>
                        <h6>{response.area}</h6>
                        <p>
                          <strong>Descrição:</strong> {response.description}
                        </p>
                        <p>
                          <strong>Data de Criação:</strong>{" "}
                          {formatDate(response.createdAt)}
                        </p>
                        <p>
                          <strong>Nota de Satisfação:</strong>{" "}
                          {response.evaluation?.review || "Sem review"}
                        </p>
                        <p>
                          <strong>
                            Status:
                            <span
                              style={{
                                color:
                                  SATISFACTION_COLORS[response.status]?.color ||
                                  "black",
                              }}
                            >
                              {" " + response.status}
                            </span>
                          </strong>
                        </p>
                        <p>
                          <strong>Executor:</strong>{" "}
                          {response.executorName || "Sem executor"}
                        </p>
                        <a
                          href={`/details/${response.id}`}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/details/${response.id}`, {
                              state: {
                                from: [
                                  {
                                    name: "Mapa de Satisfação",
                                    href: "/satisfaction-map",
                                  },
                                ],
                              },
                            });
                          }}
                        >
                          <FiEdit3 size={20} color="#794f35" />
                        </a>
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            <div className="side">
              <div className="side-info">
                <MenuIcon
                  fontSize="small"
                  className="icon"
                  style={{ color: "#41414d" }}
                />
                <div className="denuncias-container">
                  <InfoReviewComplaint
                    complaints={complaints}
                    itemCliked={selectedItem}
                    setItemCliked={setSelectedItem}
                  />
                </div>
              </div>
            </div>
          </MapContainer>
        </div>
      </Grid>
    </Grid>
  );
}
